const { Icon } = wp.components;

const CategoryIcon = ({ category, size = 16 }) => {
  if (category?.icon && typeof category?.icon === 'string' && category.icon.includes('http')) {
    return <img className="conditional-blocks-category-icon" src={category.icon} alt="" width={size} height={size} />;
  } else if (category?.icon && typeof category?.icon === 'string') {
    return (
      <span className="conditional-blocks-category-icon">
        <Icon icon={category.icon} size={size} />
      </span>
    );
  } else {
    return (
      <span className="conditional-blocks-category-icon">
        <Icon icon="admin-plugins" size={size} />
      </span>
    );
  }
};

export default CategoryIcon;
